import { Card } from '@getpay93/ui';

/** Sección vacía W1; las pantallas reales llegan en W2/W3. */
export function PlaceholderSection({ title }: { title: string }) {
  return (
    <Card>
      <h2 style={{ margin: 0, fontSize: 18, fontWeight: 800, color: 'var(--text-strong)' }}>{title}</h2>
      <p style={{ marginBottom: 0, color: 'var(--text-hint)' }}>Pantalla en construcción (W2/W3).</p>
    </Card>
  );
}
